/* ======================================================
   GLOBAL BOOTSTRAP – MUST LOAD BEFORE PAGE LOGIC
   (Safe stubs + helpers)
====================================================== */

(function () {
  if (window.__customGlobalInit) return;
  window.__customGlobalInit = true;

  /* ---------- GLOBAL SAFE STUBS ---------- */
  const noop = function () {};

  // Throttle utility for scroll events (reduces TBT)
  function throttle(callback, delay = 100) {
    let requestId = null;
    const later = (context) => () => {
      requestId = null;
      callback.apply(context);
    };
    return function(...args) {
      if (requestId === null) {
        requestId = requestAnimationFrame(later(this));
      }
    };
  }
  window.throttle = throttle;

  window.quickAdd = window.quickAdd || noop;
  window.clearAllCart = window.clearAllCart || noop;
  window.customFilters = window.customFilters || noop;
  window.recentlyViewed = window.recentlyViewed || noop;
  window.executeOnSmallScreen = window.executeOnSmallScreen || noop;
  window.productInfo = window.productInfo || noop;
  window.disabledOption1 = window.disabledOption1 || noop;
  window.quickViewPopupAdd = window.quickViewPopupAdd || noop;

  /* ===============================
   GLOBAL UI (ALL PAGES)
================================ */
(function () {
  function initGlobalUI() {
    /* Back To Top */
    const backToTop = document.querySelector(".backtotop_mobile_button");
    if (backToTop && !backToTop.dataset.bound) {
      backToTop.dataset.bound = "true";
      backToTop.addEventListener("click", () =>
        window.scrollTo({ top: 0, behavior: "smooth" })
      );
    }

    /* Footer Accordion */
    const footerBlocks = document.querySelectorAll(".footer-col");
    footerBlocks.forEach((block) => {
      const title = block.querySelector(".footermenu_title");
      if (!title || title.dataset.bound) return;

      title.dataset.bound = "true";
      title.addEventListener("click", () => {
        footerBlocks.forEach((other) => {
          if (other !== block) {
            other
              .querySelector(".footermenu_title")
              ?.classList.remove("active");
            other
              .querySelector(".footermenu_title")
              ?.nextElementSibling?.classList.remove("active");
          }
        });
        title.classList.toggle("active");
        title.nextElementSibling?.classList.toggle("active");
      });
    });
  }

  // Execute immediately for instant accordion loading
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGlobalUI);
  } else {
    initGlobalUI();
  }
})();

/* ===============================
   GLOBAL COMMERCE LOGIC
   (Now implemented in theme.js with event delegation)
================================ */

// These functions are now implemented in theme.js with proper event delegation
// and cleanup to prevent multiple event bindings and improve INP performance.
// Keeping stubs here for backward compatibility.
window.cartRecommendationSlider = window.cartRecommendationSlider || function () {};
window.quickAdd = window.quickAdd || function () {};
window.clearAllCart = window.clearAllCart || function () {};

/* Quick View Popup Add To Cart */
window.quickViewPopupAdd = function (btn) {
  if (!btn || btn.dataset.bound) return;
  // Don't bind to notify-me-btn
  if (btn.classList.contains('notify-me-btn')) return;
  btn.dataset.bound = "true";

  btn.addEventListener("click", async (e) => {
    e.preventDefault(); // Prevent default form submission
    const id = btn.getAttribute("variant-id");
    if (!id) return;

    // Set aria-busy to show loader
    btn.setAttribute("aria-busy", "true");

    try {
      // Prepare sections to bundle (get cart drawer section)
      let sectionsToBundle = [];
      const cartDrawerElement = document.querySelector("cart-drawer");
      if (cartDrawerElement) {
        const sectionId = cartDrawerElement.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (sectionId) {
          sectionsToBundle.push(sectionId);
        }
      }
      
      // Add to cart with sections
      const formData = new FormData();
      formData.set("id", id);
      formData.set("quantity", "1");
      if (sectionsToBundle.length > 0) {
        formData.set("sections", sectionsToBundle.join(","));
      }
      
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      
      const addResult = await addResponse.json();
      
      if (addResponse.ok) {
        // Fetch updated cart
        const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
        const cart = await cartResponse.json();
        
        // Add sections from add response
        if (addResult.sections) {
          cart.sections = addResult.sections;
        }
        
        // Dispatch cart:change event on documentElement (for cart count listener)
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: { 
              cart: cart
            }
          })
        );
        
        // Open cart drawer
        document
          .querySelector(".header__icon-list [aria-controls='cart-drawer']")
          ?.click();
      }
    } catch (error) {
      // Silent error handling
    } finally {
      // Remove aria-busy to hide loader
      btn.removeAttribute("aria-busy");
    }
  });
};

  /* ---------- TEMPLATE HELPERS ---------- */
  window.TEMPLATE = {
    isHome() {
      return document.body.classList.contains("template-index");
    },
    isPDP() {
      return document.body.classList.contains("template-product");
    },
    isCollection() {
      return document.body.classList.contains("template-collection");
    },
    isAccount() {
      return document.body.classList.contains("template-customers");
    },
  };
})();

/* ===============================
   GLOBAL SHARE BUTTON (PDP & COLLECTION)
================================ */

window.initShareButton = function initShareButton() {
  var shareButton = document.querySelector(".shareButton");
  if(shareButton && !shareButton.dataset.initialized){
    shareButton.dataset.initialized = 'true';
    
    shareButton.addEventListener('click', () => {
      const url = window.location.href; // Get the current URL
      
      if (navigator.share && window.innerWidth <= 700) {
        // Mobile: Use native share API
        navigator.share({
          title: document.title,
          text: 'Check this out!',
          url: url
        }).catch(function(error) {
          // Silent error handling
        });
      } else if (window.innerWidth > 700) {
        // Desktop: Copy to clipboard
        navigator.clipboard.writeText(url).then(() => {
          shareButton.classList.add('active');
          setTimeout(function() {
            shareButton.classList.remove('active');
          }, 2000);
        }).catch(err => {
          // Fallback: show share options
          var shareUrl = encodeURIComponent(url);
          var whatsappLink = 'https://wa.me/?text=' + shareUrl;
          var telegramLink = 'https://t.me/share/url?url=' + shareUrl;
          
          var fallbackHtml = '<div>' +
            '<a href="' + whatsappLink + '" target="_blank">Share on WhatsApp</a>' +
            '<a href="' + telegramLink + '" target="_blank">Share on Telegram</a>' +
            '</div>';
          document.body.insertAdjacentHTML('beforeend', fallbackHtml);
        });
      } else {
        // Fallback for mobile without share API
        var shareUrl = encodeURIComponent(url);
        var whatsappLink = 'https://wa.me/?text=' + shareUrl;
        var telegramLink = 'https://t.me/share/url?url=' + shareUrl;
        
        var fallbackHtml = '<div>' +
          '<a href="' + whatsappLink + '" target="_blank">Share on WhatsApp</a>' +
          '<a href="' + telegramLink + '" target="_blank">Share on Telegram</a>' +
          '</div>';
        document.body.insertAdjacentHTML('beforeend', fallbackHtml);
      }
    });
  }
};

/* ===============================
   HOME PAGE LOGIC (OPTIMIZED)
================================ */

(function () {
  if (!document.body.classList.contains("template-index")) return;

  function initHomePage() {

    /* ---------- Tab Featured Section ---------- */
    const tabCollection = document.querySelector(".tab-featured-collection");
    if (tabCollection) {
      const tabTitles = tabCollection.querySelectorAll(".tabheader li");
      const tabContentBlocks =
        tabCollection.querySelectorAll(".tabinfo_block");

      tabTitles.forEach((tabTitle) => {
        if (tabTitle.dataset.bound) return;
        tabTitle.dataset.bound = "true";
        tabTitle.addEventListener("click", () => {
          const targetId = tabTitle.getAttribute("data-title");

          tabTitles.forEach((title) =>
            title.classList.remove("active")
          );
          tabTitle.classList.add("active");

          tabContentBlocks.forEach((block) => {
            const isActive =
              block.getAttribute("data-content") === targetId;
            block.classList.toggle("active", isActive);
            block.classList.toggle("hidden", !isActive);
          });
        });
      });
    }

    /* ---------- Show More / Less Collection Blocks ---------- */
    const blocks = document.querySelectorAll(".collction_block");
    const showBlockBtn = document.querySelector(".showBlock");

    if (blocks.length && showBlockBtn) {
      blocks.forEach((block) =>
        block.classList.remove("hidden")
      );
      showBlockBtn.classList.add("seeless");

      showBlockBtn.addEventListener("click", () => {
        const isSeeLess =
          showBlockBtn.classList.contains("seeless");

        blocks.forEach((block, index) => {
          block.classList.toggle(
            "hidden",
            isSeeLess && index >= 9
          );
        });

        showBlockBtn.classList.toggle("seeless", !isSeeLess);
        showBlockBtn.classList.toggle("seemore", isSeeLess);
      });
    }
  }

  if (document.readyState === "complete") {
    initHomePage();
  } else {
    window.addEventListener("load", initHomePage); // Defer to load for better FCP
  }
})();

/* ===============================
   PRODUCT PAGE LOGIC (OPTIMIZED)
================================ */

(function () {
  if (!document.body.classList.contains("template-product") || document.body.classList.contains("template-crazy_deals")) return;

  function initPDP() {

    //*** START Product page show discount base and saving price in product media

    function updateDiscountDisplay() {
      var discountPercentage = document.querySelector("on-sale-badge[data-discount]");
      if(!discountPercentage) return false;
      
      var discount = discountPercentage.getAttribute("data-discount");
      var price = discountPercentage.getAttribute("data-price");
      var compare_price = discountPercentage.getAttribute("data-comapre-price");
      var difference = discountPercentage.getAttribute("saved_price_default");

      var discountElement = document.querySelector(".discountPercentage span");
      if (discountElement) {
        discountElement.textContent = discount;
      }
      
      var stickyBarElem = document.querySelector(".pdp-stickybar .stickybar-wrap");
      if (stickyBarElem) {
        stickyBarElem.querySelector(".discount-percentage span") && (stickyBarElem.querySelector(".discount-percentage span").textContent = discount);
        stickyBarElem.querySelector(".product-price") && (stickyBarElem.querySelector(".product-price").textContent = price);
        stickyBarElem.querySelector(".product-compare-price") && (stickyBarElem.querySelector(".product-compare-price").textContent = compare_price);
        stickyBarElem.querySelector(".updated_saved_value") && (stickyBarElem.querySelector(".updated_saved_value").textContent = difference);
        var cartBtnpriceElem = stickyBarElem.querySelector(".cart-btn .price-block");
        if(cartBtnpriceElem){
          cartBtnpriceElem.querySelector(".variant-price") && (cartBtnpriceElem.querySelector(".variant-price").textContent = price);
          cartBtnpriceElem.querySelector(".variant-compare-price") && (cartBtnpriceElem.querySelector(".variant-compare-price").textContent = compare_price);
        }
      }
      return true;
    }

// Optimized discount display with better retry logic
function initDiscountDisplay() {
  // Small initial delay for DOM readiness, then try immediate update
  setTimeout(function() {
    if (updateDiscountDisplay()) return;
    
    // Retry with exponential backoff if needed (max 3 attempts)
    var attempts = 0;
    var maxAttempts = 3;
    
    function tryUpdate() {
      attempts++;
      if (updateDiscountDisplay() || attempts >= maxAttempts) return;
      
      requestAnimationFrame(() => {
        setTimeout(tryUpdate, 50 * attempts);
      });
    }
    
    tryUpdate();
  }, 100);
}

initDiscountDisplay();

// Listen for variant changes (throttled for better performance)
var lastVariantUpdate = 0;
document.addEventListener("variant:change", function(event) {
  var now = Date.now();
  if (now - lastVariantUpdate < 100) return; // Throttle rapid changes
  lastVariantUpdate = now;
  
  requestAnimationFrame(() => {
    setTimeout(updateDiscountDisplay, 50);
  });
});

//*** END Product page show discount base and saving price in product media

    // Initialize share button for product page
    window.initShareButton();

    /* ---------- Media Key Highlights ---------- */
    const keyHighlightBtn = document.querySelector(
      ".main-productimage-slider .pdp_highlights_button"
    );
    const highlightContent = document.querySelector(
      ".pdp_highlights_contnet"
    );

    if (keyHighlightBtn && highlightContent) {
      keyHighlightBtn.addEventListener("click", () => {
        keyHighlightBtn.classList.toggle("active");
        highlightContent.classList.toggle("active");
      });
    }

    /* ---------- Benefits Swiper ---------- */
    (function () {
  function initBenefitsSlider(root = document) {
    const slider = root.querySelector('.product-info__benefits-details');
    if (!slider || slider.dataset.init) return;

    const track = slider.querySelector('.benefits-wrapper');
    const prev = slider.querySelector('.benefit-prev');
    const next = slider.querySelector('.benefit-next');
    const item = track?.querySelector('.benefit-block');

    if (!track || !prev || !next || !item) return;

    slider.dataset.init = 'true';

    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      slider.classList.toggle('has-scroll', maxScroll > 10);
    }

    function scroll(dir) {
      const gap = parseInt(getComputedStyle(track).gap) || 12;
      const amount = item.offsetWidth + gap;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    requestAnimationFrame(updateArrows);
  }

  /* Initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBenefitsSlider());
  } else {
    initBenefitsSlider();
  }

  /* Shopify section + variant safety */
  document.addEventListener('shopify:section:load', e => {
    initBenefitsSlider(e.target);
  });

  document.addEventListener('variant:change', () => {
    initBenefitsSlider();
  });
})();

    /* ---------- FAQ Accordion ---------- */
    function initFaqAccordion() {
      const faqTabs = document.querySelectorAll(
        ".product-info-faqblock .tab_wrapper"
      );

      faqTabs.forEach((tab) => {
        const title = tab.querySelector(".tab-title");
        const content = tab.querySelector(".tab-block");

        if (!title || !content || title.dataset.bound) return;
        title.dataset.bound = "true";

        title.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Get current state before any DOM manipulation
          const isCurrentlyActive = title.classList.contains("active");

          // Close all other tabs
          faqTabs.forEach((other) => {
            if (other !== tab) {
              const otherTitle = other.querySelector(".tab-title");
              const otherContent = other.querySelector(".tab-block");
              if (otherTitle) otherTitle.classList.remove("active");
              if (otherContent) otherContent.classList.add("hidden");
            }
          });

          // Toggle current tab based on previous state
          if (isCurrentlyActive) {
            title.classList.remove("active");
            content.classList.add("hidden");
          } else {
            title.classList.add("active");
            content.classList.remove("hidden");
          }
        }, { passive: false });
      });
    }

    // Initialize on page load
    initFaqAccordion();

    // Re-initialize on variant change
    document.addEventListener('variant:change', () => {
      initFaqAccordion();
    });

    // Re-initialize on accordion reinit event
    document.addEventListener('accordion:reinit', () => {
      initFaqAccordion();
    });

/* ---------- OFFER CODE COPY ---------- */
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.offer_code');
    if (!btn) return;

    const text = btn.textContent?.trim();
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      btn.classList.add('active');
      setTimeout(() => {
        btn.classList.remove('active');
      }, 2000);
    });
  });
})();

    /* ---------- Sticky Cart (Scroll Optimized) ---------- */
    const buyButtons = document.querySelector(
      ".quantity_buyButton_wrapper"
    );
    const stickyBar = document.querySelector(".pdp-stickybar");

    if (buyButtons && stickyBar) {
      let ticking = false;

      const checkPosition = () => {
        const rect = buyButtons.getBoundingClientRect();
        stickyBar.classList.toggle("active", rect.bottom <= 0);
        ticking = false;
      };

      window.addEventListener(
        "scroll",
        () => {
          if (!ticking) {
            requestAnimationFrame(checkPosition);
            ticking = true;
          }
        },
        { passive: true }
      );
    }
    
    /* ---------- Variant Size Disable Logic ---------- */
    window.disabledOption1 = function (newVariant) {
      const option2 = newVariant?.option2;
      if (!option2) return;

      const variantJson = JSON.parse(
        document
          .querySelector("variant-picker")
          ?.getAttribute("data-variant") || "[]"
      );

      const allowed = variantJson
        .filter((v) => v.option2 === option2)
        .map((v) => v.option1);

      document
        .querySelectorAll(
          ".variant-picker__option.size .block-swatch"
        )
        .forEach((label) => {
          label.classList.toggle(
            "is-disabled",
            !allowed.includes(label.getAttribute("data-value"))
          );
        });
    };
  }

    // Disabled size variant ion base selected flavour on Product page
  var selectedOption = document.querySelector(".variant-picker__option.flavour");
  if(selectedOption){
    var checkedInput = selectedOption.querySelector("input:checked");
    if (!checkedInput) return; // Safety check
    
    var label = checkedInput.nextElementSibling;
    if (!label) return; // Safety check
    
    var option2 = label.getAttribute("data-value");
    var variantPickerElement = document.querySelector("variant-picker");
    
    if (!variantPickerElement) return; // Safety check - element must exist
    
    var variantDataAttr = variantPickerElement.getAttribute("data-variant");
    if (!variantDataAttr) return; // Safety check - attribute must exist
    
    try {
      var variantJson = JSON.parse(variantDataAttr);
      if (Array.isArray(variantJson)) {
        let matchingVariants = variantJson.filter(variant => variant.option2 === option2);
        let option1Values = matchingVariants.map(variant => variant.option1);
                      
        // Select all labels with a data-value attribute
        document.querySelectorAll('.variant-picker__option.size .block-swatch').forEach(label => {
          label.classList.remove('is-disabled');
          const value = label.getAttribute('data-value');          
          // If the value is NOT in filteredValues, add 'disabled' class
            if (!option1Values.includes(value)) {
              label.classList.add('is-disabled');
            }
        });
      }
    } catch (error) {
      // Silent error handling - JSON parse may fail
    }
  }

  // Execute immediately for instant accordion loading
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPDP);
  } else {
    initPDP();
  }
})();

/* ===============================
   COLLECTION PAGE LOGIC (OPTIMIZED - INSTANT FILTER DISPLAY)
================================ */

(function () {
  if (!document.body.classList.contains("template-collection")) return;

  let filterObserver = null;
  let initScheduled = false;
  let rerenderObserver = null; // Declare rerenderObserver variable

  // Initialize filter accordion tabs - INSTANT (no delays)
  function initFilterAccordionTabs(isRefresh = false) {
    const tabTitles = document.querySelectorAll("facet-drawer .tab_title");
    const accordions = document.querySelectorAll("facet-drawer .filter-accordian");
    
    if (!tabTitles.length || !accordions.length) {
      return false;
    }
    
    // Set first accordion as active
    accordions.forEach((accordion, index) => {
      if (index === 0) {
        accordion.classList.add("active");
      } else {
        accordion.classList.remove("active");
      }
    });
    
    // Bind tab click events
    // On refresh (facet:update), skip binding check to allow fresh listeners
    tabTitles.forEach(function(tabTitle){
      if (!isRefresh && tabTitle.dataset.bound === "true") return;
      tabTitle.dataset.bound = "true";
      
      const clickHandler = function() {
        tabTitles.forEach(t => t.classList.remove("active"));
        tabTitle.classList.add("active");
        
        const tabLabel = tabTitle.getAttribute("data-label");
        accordions.forEach(accordion => accordion.classList.remove("active"));
        
        const dataAccordian = document.querySelector("facet-drawer .filter-accordian[data-content='" + tabLabel + "']");
        if (dataAccordian) {
          dataAccordian.classList.add('active');
          
          if (!dataAccordian.hasAttribute('open')) {
            const summary = dataAccordian.querySelector("summary");
            if (summary) {
              requestAnimationFrame(() => {
                summary.click();
              });
            }
          }
        }
      };
      
      tabTitle.addEventListener('click', clickHandler);
    });
    
    // Trigger first tab INSTANTLY
    if (tabTitles[0]) {
      requestAnimationFrame(() => {
        tabTitles[0].click();
      });
    }

    return true;
  }

  // Smart watcher - triggers init as soon as filters appear in DOM
  function watchForFilterElements() {
    // Try immediate init first (filters may already be in DOM)
    if (initFilterAccordionTabs()) {
      return;
    }

    const facetDrawer = document.querySelector("facet-drawer");
    if (!facetDrawer) {
      requestAnimationFrame(watchForFilterElements);
      return;
    }

    // If not ready, watch for when tabs get added to DOM
    if (filterObserver) filterObserver.disconnect();
    
    filterObserver = new MutationObserver(() => {
      if (!initScheduled) {
        initScheduled = true;
        requestAnimationFrame(() => {
          if (initFilterAccordionTabs()) {
            if (filterObserver) filterObserver.disconnect();
          }
          initScheduled = false;
        });
      }
    });

    filterObserver.observe(facetDrawer, {
      childList: true,
      subtree: true
    });
  }

  // Initialize sortBy popup
  function initSortByPopup() {
    var sortByBtn = document.querySelector(".mobile-sortby-button");
    var sortByPopup = document.querySelector(".mobile-sortby-popup");
    var mobileOverlay = document.querySelector(".mobile-sortby-overlay");
    
    if(!sortByBtn) return;

    if (!sortByBtn.dataset.bound) {
      sortByBtn.dataset.bound = "true";
      sortByBtn.addEventListener("click", function(){
        document.body.classList.add('sortby-popup-active');        
        sortByPopup.classList.add("active");
        mobileOverlay.classList.add("active");
      });
    }

    const closeButton = document.querySelector('.sortby-popupclose-button');
    const overlay = document.querySelector('.mobile-sortby-overlay');
    
    const handleClick = () => {
      sortByPopup.classList.remove("active");
      mobileOverlay.classList.remove('active');
      document.body.classList.remove('sortby-popup-active');
    };
    
    if(closeButton && !closeButton.dataset.bound) {
      closeButton.dataset.bound = "true";
      closeButton.addEventListener('click', handleClick);
    }
    if(overlay && !overlay.dataset.bound) {
      overlay.dataset.bound = "true";
      overlay.addEventListener('click', handleClick);
    }
  }

  // Initialize custom filters
  window.customFilters = function customFilters(){
    //*** START collection page filter button refresh project without refresh 
    var filterTags = document.querySelectorAll(".collection__top-bar .filterTag");
    if(filterTags.length){
      filterTags.forEach(function(filtertag){
        var filterTagBtn = filtertag.querySelector("button");
        if (filterTagBtn.dataset.bound) return;
        filterTagBtn.dataset.bound = "true";
        filterTagBtn.addEventListener('click',function(){
          filterTagBtn.classList.add('active');
          var filterTagVal = filterTagBtn.getAttribute("data-filtertag");
          var filterElements = document.querySelectorAll(".checkbox-container");
          filterElements.forEach(function(filterElem){
            var inputElem = filterElem.querySelector("input");
            var inputVal = inputElem.getAttribute("data-value");
            if(filterTagVal == inputVal){
              inputElem.click();
            }
          });
        });
      });
    }

    var sortCustomFilters = document.querySelectorAll(".sortby-popup-filter li");
    if(sortCustomFilters.length){
      sortCustomFilters.forEach(function(sortCustomBtn){
        if (sortCustomBtn.dataset.bound) return;
        sortCustomBtn.dataset.bound = "true";
        sortCustomBtn.addEventListener('click',function(){
          var sortCustomval = sortCustomBtn.getAttribute("data-sort");
          var filterElements = document.querySelectorAll(".checkbox-container");
          filterElements.forEach(function(filterElem){
            var inputElem = filterElem.querySelector("input");
            var inputVal = inputElem.getAttribute("data-value");
            if(sortCustomval == inputVal){
              inputElem.click();
            }
          });
        });
      });
    }
    //*** END
  };

  // Update active filter tags when facet changes
  function updateActiveFilterTags() {
    // Reset all filter buttons first
    document.querySelectorAll(".collection__top-bar .filterTag button").forEach(btn => {
      btn.classList.remove("active");
    });

    // Get all checked inputs and add active class to matching filter buttons
    var activeFilterElems = document.querySelectorAll(".filtervalues .checkbox-container input:checked");
    if(activeFilterElems.length){
      activeFilterElems.forEach(function(activeFilter){
        var activeValue = activeFilter.getAttribute("data-value");
        if(activeValue){
          var filterBtnElems = document.querySelectorAll(".collection__top-bar .filterTag");
          filterBtnElems.forEach(function (filterBtnElem) {
            var filterBtn = filterBtnElem.querySelector("button");
            var btnval = filterBtn.getAttribute("data-filtertag")
            if (btnval === activeValue) {
              filterBtn.classList.add("active");
            }
          });
        }
      });
    }
  }

  // Watch for DOM changes after facet update
  function waitForFacetRerender() {
    const facetDrawer = document.querySelector("facet-drawer");
    if (!facetDrawer) return;

    let rerenderDetected = false;

    rerenderObserver = new MutationObserver(() => {
      if (!rerenderDetected) {
        rerenderDetected = true;
        
        // Wait for DOM to stabilize before reinitializing
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Check if filter values are now present
            const filterValues = document.querySelector("facet-drawer .filtervalues");
            if (!filterValues || filterValues.children.length === 0) {
              // If not ready yet, let observer continue
              rerenderDetected = false;
              return;
            }

            // Clear all old bindings
            const allTabs = document.querySelectorAll("facet-drawer .tab_title");
            allTabs.forEach(tab => {
              delete tab.dataset.bound;
            });

            // Reinitialize everything
            updateActiveFilterTags();
            
            // Force reinitialization with fresh bindings
            const success = initFilterAccordionTabs(true);
            
            if (success) {
              window.customFilters();
              rerenderObserver.disconnect();
            } else {
              // If init failed, reset and try again
              rerenderDetected = false;
            }
          });
        });
      }
    });

    rerenderObserver.observe(facetDrawer, {
      childList: true,
      subtree: true
    });

    // Fallback timeout
    setTimeout(() => {
      if (rerenderObserver) {
        rerenderObserver.disconnect();
        // Try one last time
        const allTabs = document.querySelectorAll("facet-drawer .tab_title");
        allTabs.forEach(tab => {
          delete tab.dataset.bound;
        });
        initFilterAccordionTabs(true);
        window.customFilters();
      }
    }, 2000);
  }

  // Listen for facet updates with instant response
  document.addEventListener("facet:update", (event) => {
    updateActiveFilterTags();
    waitForFacetRerender();
    // Re-initialize share button after collection page updates
    setTimeout(() => {
      window.initShareButton();
    }, 100);
  });

  // Main initialization function
  function initCollectionPage() {
    initSortByPopup();
    watchForFilterElements(); // Start watching IMMEDIATELY - no setTimeout
    window.customFilters(); // Initialize custom filter listeners
    window.initShareButton(); // Initialize share button
  }

  // Start initialization at DOMContentLoaded (earlier than load)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCollectionPage);
  } else {
    // Already loaded, initialize immediately
    initCollectionPage();
  }
})();


/* ===============================
   GLOBAL SAFE INIT RUNNER
================================ */

function runGlobalCommerce() {
  // Only call functions that are NOT already handled by theme.js cart events
  window.recentlyViewed();
  
  // Cart-related functions (cartRecommendationSlider, quickAdd, clearAllCart)
  // are now exclusively handled by theme.js through cart:refresh and cart:change events
  // This prevents duplicate event bindings and improves INP performance
}

/* Initial run */
if (document.readyState === "complete") {
  runGlobalCommerce();
} else {
  window.addEventListener("load", runGlobalCommerce); // Defer to load for better FCP
}